var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"common-select",domProps:{"value":_vm.value},on:{"change":_vm.onChange}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.placeholder))]),_vm._l((_vm.items),function(item){return _c('option',{key:item[_vm.keyField],domProps:{"value":item[_vm.valueField]}},[_vm._v(" "+_vm._s(item[_vm.labelField])+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }